<div class="table-header-row">
  <div class="sticky-header-cell-left header-label-cell"></div>
  <div class="header-rows">
    <div class="months-wrapper">
      <ng-container
        *ngFor="let monthGroup of (calendarTableHelper$ | async)?.months">
        <div class="month-wrapper">
          <div
            class="month-name"
            *ngIf="monthGroup.days.length > 2">
            {{ monthGroup.days[0].date | date: "MMMM yyyy" }}
          </div>

          <div class="hidden-days">
            <div
              class="hidden-day"
              *ngFor="let day of monthGroup.days"></div>
          </div>
        </div>
      </ng-container>
    </div>
    <div
      class="weeks-wrapper"
      *ngIf="selectionInfo$ | async as selectionInfo">
      <ng-container
        *ngFor="let weekGroup of (calendarTableHelper$ | async)?.weeks">
        <div class="week-wrapper">
          <div class="calendar-week">
            {{ "KW" + " " + (weekGroup.days[0].date | date: "ww") }}
          </div>
          <div
            class="hidden-days"
            (mouseleave)="setHoveredDayIndex(undefined)">
            <div
              class="hidden-day"
              *ngFor="let day of weekGroup.days"
              [matTooltip]="(day.date | date: 'dd.MM.yyy') || ''"
              matTooltipPosition="above"
              (mousedown)="selectDayMouseDown(day, $event)"
              (mouseup)="selectDayMouseUp(day.date, $event)"
              (mouseenter)="setHoveredDayIndex(day.totalIndex)"
              [class.is-first-week-day]="
                day.totalIndex === 0 || (day.date | date: 'cc') === '1'
              "
              [class.selected]="
                selectionInfo?.selectedIndexes?.has(day.totalIndex) ?? false
              "
              [class.first-selected]="
                day.totalIndex === (selectionInfo?.startIndex ?? -1) &&
                (((activeDayRange$ | async) ?? 0) ||
                  !selectionInfo?.hasHover ||
                  (selectionInfo?.hoveredIndex ?? 0) >=
                    (selectionInfo?.startIndex ?? 0))
              "
              [class.last-selected]="
                day.totalIndex === (selectionInfo?.endIndex ?? -1) &&
                (((activeDayRange$ | async) ?? 0) ||
                  !selectionInfo?.hasHover ||
                  (selectionInfo?.hoveredIndex ?? 0) <=
                    (selectionInfo?.startIndex ?? 0))
              "
              [class.selection-hovered]="
                !((activeDayRange$ | async) ?? 0) &&
                selectionInfo?.startIndex !== undefined &&
                selectionInfo?.hasHover &&
                ((day.totalIndex > (selectionInfo?.startIndex ?? 0) &&
                  day.totalIndex <= (selectionInfo?.hoveredIndex ?? 0)) ||
                  (day.totalIndex < (selectionInfo?.startIndex ?? 0) &&
                    day.totalIndex >= (selectionInfo?.hoveredIndex ?? 0)))
              "
              [class.last-selection-hovered]="
                !((activeDayRange$ | async) ?? 0) &&
                selectionInfo?.startIndex !== undefined &&
                selectionInfo?.isHoverAfterStart &&
                day.totalIndex === (selectionInfo?.hoveredIndex ?? -1)
              "
              [class.first-selection-hovered]="
                !((activeDayRange$ | async) ?? 0) &&
                selectionInfo?.startIndex !== undefined &&
                selectionInfo?.isHoverBeforeStart &&
                day.totalIndex === (selectionInfo?.hoveredIndex ?? -1)
              "
              [class.is-today]="
                (day.date | date: 'yyyy.MM.dd') == ((today$ | async) ?? '') &&
                ((calendarTableHelper$ | async)?.start | date: 'yyyy.MM.dd') !==
                  ((today$ | async) ?? '')
              ">
              <ng-container
                *ngIf="day.totalIndex === (selectionInfo?.startIndex ?? -1)"
                ><div class="selection-label">
                  <ng-container
                    *ngIf="(((activeDayRange$ | async) ?? 0) || 0) === 1">
                    {{ day.date | date: "dd" }}
                  </ng-container>
                  <ng-container
                    *ngIf="(((activeDayRange$ | async) ?? 0) || 0) > 1">
                    {{ day.date | date: "dd.MM" }}
                  </ng-container>
                </div></ng-container
              >
              <ng-container
                *ngIf="
                  day.totalIndex === (selectionInfo?.endIndex ?? -1) &&
                  (((activeDayRange$ | async) ?? 0) || 0) > 4
                "
                ><div class="selection-label">
                  {{ day.date | date: "dd.MM" }}
                </div></ng-container
              >
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
  <div class="invisible-scrollbar"></div>
</div>
